export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de pedidos"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del pedido"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar pedido"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar pedido ", _interpolate(_named("code"))])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Estás seguro de que deseas eliminar este pedido?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "items": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ítems"])}
        }
      }
    }
  })
}